// src/beta/hooks/useCatalogQuery.ts
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getCatalog } from '@/beta/services/catalog';
import type { CatalogPayload } from '@/beta/types/catalog';

export function useCatalogQuery() {
  return useQuery<CatalogPayload>({
    queryKey: ['beta', 'catalog'],
    queryFn: ({ signal }) => getCatalog({ signal }),
    staleTime: 5 * 60 * 1000,
  });
}

/**
 * Hook returning a stable `prefetchShowcase(id)` callback. Phase C wires
 * an empty placeholder — Phase D replaces the inner queryFn with the
 * real `getShowcase`. The cache slot exists either way so the Focus
 * route can read-from-cache without a flash.
 */
export function usePrefetchShowcase() {
  const queryClient = useQueryClient();
  return (vehicleId: string) => {
    queryClient.prefetchQuery({
      queryKey: ['beta', 'showcase', vehicleId],
      // Phase D will replace this placeholder with the real fetcher.
      queryFn: async () => null,
      staleTime: 60 * 1000,
    });
  };
}
